module.exports = __webpack_public_path__ + "img/bandera_usa.69b202e2.svg";